import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import {
  IssuancesActionTypes,
  ResponseDataRequests,
  ResponseIssuesOrganization,
  TicketEmission
} from './types'

type Options = {
  filterOrganizationsId?: string
  filterStatus?: string[]
  filterTenantId?: string
  page?: number
  request_agency_ids?: string[]
  request_ids?: string[]
  request_numbers?: string
  request_title?: string
}

export const getIssuances = createAction(
  IssuancesActionTypes.GET_ISSUANCES,
  action =>
    (
      options: Options = {
        filterStatus: [],
        page: 1,
        request_agency_ids: [],
        request_ids: []
      }
    ) =>
      action({ options })
)

export const getIssuancesFailure = createAction(
  IssuancesActionTypes.GET_ISSUANCES_FAILURE,
  action => (message: string) => action({ message })
)

type GetIssuancesSuccessAction = Pick<
  ResponseDataRequests,
  'requests' | 'request_totals' | 'total_results'
> & {
  organizations: ResponseIssuesOrganization[]
}
export const getIssuancesSuccess = createAction(
  IssuancesActionTypes.GET_ISSUANCES_SUCCESS,
  action =>
    ({
      organizations,
      request_totals,
      requests,
      total_results
    }: GetIssuancesSuccessAction) =>
      action({ requests, request_totals, total_results, organizations })
)

interface SendIssuanceProps {
  request_agency_emission_id: Id
  request_agency_id: Id
  status: 'APPROVED' | 'REPROVED'
}

export const sendIssuance = createAction(
  IssuancesActionTypes.SEND_ISSUANCE,
  action => (request_agency_emissions: SendIssuanceProps[]) =>
    action({ request_agency_emissions })
)

export const sendIssuanceFailure = createAction(
  IssuancesActionTypes.SEND_ISSUANCE_FAILURE,
  action => (message: string) => action({ message })
)

export const sendIssuanceSuccess = createAction(
  IssuancesActionTypes.SEND_ISSUANCE_SUCCESS,
  action => () => action()
)

export const setTicketsEmission = createAction(
  IssuancesActionTypes.SET_TICKETS_EMISSION,
  action => (ticketsEmission: TicketEmission[]) => action({ ticketsEmission })
)
